import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#007CFF', 
      light: '#66B2FF',
      dark: '#005AC2',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#00D1FF', 
      light: '#66E4FF',
      dark: '#0099BB',
    },
    background: {
      default: '#F8FAFC', // Very light blue-gray
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A', // Slate 900
      secondary: '#64748B', // Slate 500
    },
    divider: 'rgba(0, 0, 0, 0.05)',
  },
  typography: {
    fontFamily: '"Inter", "Roboto", sans-serif',
    h1: { fontSize: '4.5rem', fontWeight: 900, letterSpacing: '-0.04em' },
    h2: { fontSize: '3.25rem', fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontSize: '2.5rem', fontWeight: 800, letterSpacing: '-0.01em' },
    h4: { fontSize: '2rem', fontWeight: 800 },
    h5: { fontSize: '1.5rem', fontWeight: 700 },
    h6: { fontSize: '1.1rem', fontWeight: 800 },
    subtitle1: { fontSize: '1.1rem', lineHeight: 1.6 },
    body1: { fontSize: '1.05rem', lineHeight: 1.7 },
    body2: { fontSize: '0.95rem', lineHeight: 1.6 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '8px 20px',
          fontWeight: 800,
          textTransform: 'none',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
          }
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #007CFF 0%, #00D1FF 100%)',
          boxShadow: '0 4px 15px rgba(0, 124, 255, 0.2)',
          '&:hover': {
            boxShadow: '0 8px 25px rgba(0, 124, 255, 0.4)',
          }
        },
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: '#FFFFFF',
          borderRadius: '12px',
          border: '1px solid rgba(0, 0, 0, 0.05)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
          '&:hover': {
            borderColor: 'rgba(0, 124, 255, 0.3)',
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: '12px',
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        'input:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 100px #F8FAFC inset !important',
          WebkitTextFillColor: '#0F172A !important',
          transition: 'background-color 5000s ease-in-out 0s',
        },
        'input:-webkit-autofill:hover': {
          WebkitBoxShadow: '0 0 0 100px #F8FAFC inset !important',
        },
        'input:-webkit-autofill:focus': {
          WebkitBoxShadow: '0 0 0 100px #F8FAFC inset !important',
        },
        'input:-webkit-autofill:active': {
          WebkitBoxShadow: '0 0 0 100px #F8FAFC inset !important',
        },
      }
    }
  }
});

export default theme;
